export default [
  {
    active: "Aktiv",
    connected: "Forbundet",
    customer_address: "Kunde adresse",
    deactive: "Deaktiv",
    empty_inprogress_order: "Ordrer du accepterer vil blive vist her",
    empty_new_order: "Venter på nye ordrer",
    empty_ready_order: "Ordrer der er klar vil blive vist her",
    extra_time: "Ekstra tid",
    live_keys: "Live nøgler",
    manage_account: "Administrer konto",
    name: "Navn",
    new_keys: "Nye nøgler",
    not_connected: "Ikke forbundet",
    notify_before: "Giv besked inden",
    offline: "Offline",
    online: "Online",
    order_number: "Ordrenummer",
    printer_status: "Printer status",
    reject: "Afvis",
    scheduled: "Planlagt",
    scheduled_orders: "Planlagte ordrer",
    scheduled_time: "Planlagt tid",
    start_prepare_from: "Start tilberedning kl:",
    store_configs: "Butikskonfigurationer",
    store_status: "Butiks status",
    test_keys: "Test nøgler",
    test_keys_alert: "Disse er testnøgler",
    ticket: "Billet",
    notity_you: "Vi giver dig besked",
    minutes_remaining: "minutter før afhentning.",
  },
];
